module.exports = __webpack_public_path__ + "static/media/tid.53d97f3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/tid.mp3
// module id = 258
// module chunks = 1